import React, { ReactNode } from 'react';
import cx from 'classnames';

import './gradient-column.css';

interface Props {
    children?: ReactNode;
    color: 'purple';
}

export const GradientColumn = ({ children, color }: Props): JSX.Element => {
    const classNames = cx('gradient-column', color, 'h-full');

    return <div className={classNames}>{children}</div>;
};
